import sliderNames from './sliderNames';

export default {
  GET_ID_TOKEN: `${sliderNames.SESSIONS}/getIdToken`,
  LOGOUT: `${sliderNames.SESSIONS}/logout`,
  GET_USER_COMPANIES: `${sliderNames.COMPANIES}/getCompanies`,
};
